// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": () => import("/opt/build/repo/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-home-home-js": () => import("/opt/build/repo/src/pages/home/home.js" /* webpackChunkName: "component---src-pages-home-home-js" */),
  "component---src-pages-index-js": () => import("/opt/build/repo/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-participants-js": () => import("/opt/build/repo/src/pages/participants.js" /* webpackChunkName: "component---src-pages-participants-js" */),
  "component---src-pages-participants-participants-js": () => import("/opt/build/repo/src/pages/participants/participants.js" /* webpackChunkName: "component---src-pages-participants-participants-js" */)
}

exports.data = () => import(/* webpackChunkName: "pages-manifest" */ "/opt/build/repo/.cache/data.json")

